import apiClient from '../client';
import type { Buyer, CreateBuyerRequest } from '../../types';

const buyerService = {
  getAll: async () => {
    const response = await apiClient.get<Buyer[]>('/buyers');
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<Buyer>(`/buyers/${id}`);
    return response.data;
  },

  create: async (data: CreateBuyerRequest) => {
    const response = await apiClient.post<Buyer>('/buyers', data);
    return response.data;
  },

  update: async (id: string, data: CreateBuyerRequest) => {
    const response = await apiClient.put<Buyer>(`/buyers/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/buyers/${id}`);
  },
};

export default buyerService;
